import { conditionsMet } from '../conditions-met/conditions-met';
export const applicableImage = (images, type, attributes, baseUrl) => {
    const applicableImages = images.filter((image) => conditionsMet(image.requirements, attributes));
    if (applicableImages.length === 0 || !baseUrl) {
        return;
    }
    return `${baseUrl}/${type}/${applicableImages[0].img}`;
};
//# sourceMappingURL=applicable-image.js.map